import React, { FC } from 'react';
import { List } from 'antd';
import { useMediaQuery } from 'react-responsive';

import { Terminal, Location } from '~/types';
import TerminalCard from './TerminalCard';
import { useDeepEffect, usePath, usePermissions } from '~/hooks';
import { terminals } from '~/routes';
import { usePageShow } from '~/hooks/usePageQuery';
import theme from '~/theme';

interface Props {
  data: Terminal[] | undefined;
  total: number;
  loading: boolean;
  locationsById: Record<string, Location> | undefined;
  accountMap?: Map<string, { id: string; number?: string }>;
  accountsDataLoading?: boolean;
}

const CardsList: FC<Props> = (props) => {
  const { data, loading, total, locationsById, accountMap, accountsDataLoading } = props;
  const { pagination, changePath } = usePath();

  const { showOpen } = usePageShow(terminals);

  let column = 3;
  const isDesktop = useMediaQuery({ minWidth: theme.breakpoints.xl });
  const isLaptop = useMediaQuery({ maxWidth: theme.breakpoints.xl });
  const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.md });
  const isMobile = useMediaQuery({ maxWidth: theme.breakpoints.sm });
  if (isDesktop) column = 4;
  if (isLaptop) column = 3;
  if (isTablet) column = 2;
  if (isMobile) column = 1;

  const pageSize = column * 3;
  useDeepEffect(() => {
    changePath({ page: 1, perPage: pageSize });
  }, [pageSize]);

  const hasAccessView = usePermissions('business.terminal.view');

  return (
    <>
      <List
        grid={{ gutter: 24, column }}
        dataSource={data}
        pagination={{
          pageSize,
          total,
          ...pagination,
          showSizeChanger: false,
        }}
        renderItem={(item) => (
          <List.Item key={item.id}>
            <TerminalCard
              data={item}
              loading={loading}
              locationsById={locationsById}
              hasAccessView={hasAccessView}
              showOpen={showOpen}
              accountMap={accountMap}
              accountsDataLoading={accountsDataLoading}
            />
          </List.Item>
        )}
      />
    </>
  );
};

export default CardsList;
